import { createReducer, on } from '@ngrx/store';
import { addGenerationError, setGeneratingReport, setNotGeneratingReport } from './generate.actions';
import { resetAllCustomPdfReportItems } from '../actions';
export const generatingReport = createReducer(false, on(setGeneratingReport, () => true), on(setNotGeneratingReport, () => false), on(resetAllCustomPdfReportItems, () => false));
export const generationErrors = createReducer([], on(addGenerationError, (state, { error }) => [...state, error]), on(resetAllCustomPdfReportItems, () => []));
